import { render, staticRenderFns } from "./consume-info.vue?vue&type=template&id=1b1f02ff&scoped=true"
import script from "./consume-info.ts?vue&type=script&lang=ts&external"
export * from "./consume-info.ts?vue&type=script&lang=ts&external"
import style0 from "./consume-info.scoped.scss?vue&type=style&index=0&id=1b1f02ff&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f02ff",
  null
  
)

export default component.exports